import { BadgeTypes } from 'dash-ui';

import { PropertyStatusesEnum } from 'gql/generated.graphql';

export const BADGE_TO_STATUS_COLOR_MAP: Record<
  PropertyStatusesEnum,
  BadgeTypes
> = {
  [PropertyStatusesEnum.Private]: 'alert',
  [PropertyStatusesEnum.Public]: 'active',
  [PropertyStatusesEnum.Draft]: 'neutral',
};
